export default [
  {
    path: 'transaction',
    name: 'transaction',
    meta: {
      title: 'Transaction History'
    },
    component: () => import('./list/TransactionListPage.vue')
  },
  {
    path: 'transaction/:uuid',
    name: 'transaction.detail',
    meta: {
      title: 'Transaction History'
    },
    component: () => import('./detail/TransactionDetailPage.vue')
  }
]
